var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", { staticClass: "vlastFooter" }, [
    _c("div", { staticClass: "container" }, [
      !_vm.$whitelabel
        ? _c(
            "div",
            { staticClass: "footer-social" },
            [
              _c("vlast-logo-monogram", {
                staticClass: "footer-logo",
                attrs: { fill: "white" },
              }),
              _vm._v(" "),
              _c("h2", [_vm._v("Unleash your star power!")]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "footer-bottom vlast-footer-bottom" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-10" }, [
            _c("p", { staticClass: "phone" }, [
              _c("i", { staticClass: "fa fa-phone" }),
              _vm._v(" "),
              _vm.$userIsAdmin
                ? _c(
                    "a",
                    { attrs: { href: _vm.getPhone(_vm.vlastContactNumber) } },
                    [_vm._v(_vm._s(_vm.vlastContactNumber))]
                  )
                : _c(
                    "a",
                    { attrs: { href: _vm.getPhone(_vm.contactNumber) } },
                    [_vm._v(_vm._s(_vm.contactNumber))]
                  ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-2" }, [
            _c("p", { staticClass: "right" }, [
              _vm._v("Copyright Pickstar © " + _vm._s(_vm.year)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "marketplaceFooter_main_section" }, [
          _c("p", { staticClass: "marketplaceFooter_generalNav phone" }, [
            _vm.privacy_link
              ? _c(
                  "a",
                  { attrs: { href: _vm.privacy_link, target: "_blank" } },
                  [_vm._v("Privacy Policy")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.tnc_link
              ? _c("a", { attrs: { href: _vm.tnc_link, target: "_blank" } }, [
                  _vm._v("Terms and Conditions"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://govlast.com/policies/privacy",
                  target: "_blank",
                },
              },
              [_vm._v("Vlast Privacy Policy")]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }